import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Layer 1",
  viewBox: "0 0 110.57 77.25"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M40.49 40.85c-.83-1.5-1.33-3.17-1.45-4.88 3.3-.07 6.56-.03 9.74.1l-8.29 4.78Zm5.34-16.62c2.14-1.06 8.46-3.47 24.14-5.51 0 0 20.8-2.61 37.76-10.21l2.84-8.52c-15.88 8.25-30.68 10.38-40.6 12.23-9.27 1.69-18.88 2.6-26.62 6.08-4.77 2.19-8.45 6.34-9.99 11.43-3.63.21-7.17.57-10.53 1.14C9.97 32.42 0 43.38 0 56.66c0 7.94 3.57 15.05 9.18 19.82l.03.09s-.01-.05-.02-.07l-.16-.74c-1.02-5.34 1.59-8.85 1.59-8.85C13.61 62.2 18.49 60 25.97 60c17.52 0 36.25 7.84 54.36 15.42l4.35 1.84 2.12-6.11c-19.59-8.16-40.65-17.59-60.83-17.59-6.78 0-14 1.59-19.04 7.52-.34-1.45-.51-2.93-.51-4.41 0-10 7.55-18.27 17.25-19.41 2.97-.45 5.96-.77 8.92-.98.33 5.13 2.75 9.69 6.42 12.83h.01l.02.02L69.9 31.31c-8.49-.97-19.1-1.88-29.54-1.79 1.2-2.29 3.12-4.15 5.46-5.27",
      style: {"fill":"#2056ae"}
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "YM-logo"}) } }